"use client";

export default function PrivacyPolicy(){
    return(
        <main className={'px-24 my-12 lg:px-6 lg:pr-10 lg:pt-4 dark:bg-background-dark'}>
            <div className="mx-auto my-6">
                <h1 className="mt-2 text-2xl font-bold tracking-tight sm:text-4xl">Introduction:</h1>
                <p className="mt-6 text-lg leading-8">
                    Welcome to Easy Pairing&apos;s Privacy Policy. We are committed to safeguarding the privacy of our users and their data. This policy outlines the nature, purpose, use, and sharing of any personal information collected.
                </p>  
            </div>
            
            <div className="mx-auto my-6">
                <h1 className="mt-2 text-2xl font-bold tracking-tight  sm:text-4xl">Data Collection:</h1>
                <h5 className="mt-8 text-2xl font-bold tracking-tight  sm:text-4xl">Types of Data Collected:</h5>
                <p className="mt-6 text-lg leading-8">
                    Personal identification information (Name, email address, phone number, etc.)
                    <br />
                    User-generated content, profiles, and interactions.
                    <br />
                    Technical data (IP address, browser type, device information, cookies, etc.)
                </p>  
            </div>
            <div className="mx-auto my-6">
                <h1 className="mt-2 text-2xl font-bold tracking-tight  sm:text-4xl">Use of Data:</h1>
                <h5 className="mt-8 text-2xl font-bold tracking-tight  sm:text-4xl">We use the collected data to:</h5>
                <p className="mt-6 text-lg leading-8">
                    Provide, maintain, and improve our platform.
                    <br />
                    Personalize user experiences.
                    <br />
                    Use AI-driven algorithms for matching and identity verification.
                    <br />
                    Respond to inquiries and support requests.
                    <br />
                    Communicate updates, offers, and promotional messages.
                </p>  
            </div>
            
            <div className="mx-auto my-6">
                <h1 className="mt-2 text-2xl font-bold tracking-tight sm:text-4xl">Data Sharing and Disclosure:</h1>
                <p className="mt-6 text-lg leading-8">
                    We do not sell your data. However, data might be shared with:
                    <br />
                    Service providers and partners are aiding our platform functions.
                    <br />
                    Law enforcement agencies, if mandated by law.
                </p>  
            </div>
            <div className="mx-auto my-6">
                <h1 className="mt-2 text-2xl font-bold tracking-tight sm:text-4xl">Data Storage and Security:</h1>
                <p className="mt-6 text-lg leading-8">
                    We implement industry-standard security measures to safeguard data.
                    <br />
                    Despite these measures, no platform is 100% secure, and we cannot guarantee absolute security.
                </p>  
            </div>
            
            <div className="mx-auto my-6">
                <h1 className="mt-2 text-2xl font-bold tracking-tight  sm:text-4xl">User Rights:</h1>
                <h5 className="mt-8 text-2xl font-bold tracking-tight  sm:text-4xl">Users have the right to:</h5>
                <p className="mt-6 text-lg leading-8">
                    Access their data.
                    <br />
                    Correct inaccuracies in their data
                    <br />
                    Withdraw consent or object to certain data uses.
                    <br />
                    Delete their account and associated data.
                </p>  
            </div>
            <div className="mx-auto my-6">
                <h1 className="mt-2 text-2xl font-bold tracking-tight sm:text-4xl">Cookies:</h1>
                <p className="mt-6 text-lg leading-8">
                    Easy Pairing uses cookies to enhance user experience, remember user preferences, and for analytical purposes.
                    <br />
                    Users can opt-out or manage cookies through their browser settings.
                </p>  
            </div>
            <div className="mx-auto my-6">
                <h1 className="mt-2 text-2xl font-bold tracking-tight sm:text-4xl">Third-party Links:</h1>
                <p className="mt-6 text-lg leading-8">
                    Our platform may contain links to external sites. We are not responsible for the privacy practices or content of these sites.
                </p>  
            </div>
            <div className="mx-auto my-6">
                <h1 className="mt-2 text-2xl font-bold tracking-tight sm:text-4xl">Changes to Privacy Policy:</h1>
                <p className="mt-6 text-lg leading-8">
                    Easy Pairing may update this policy periodically. Significant changes will be communicated to users, but we encourage regular reviews of this policy.
                </p>  
            </div>
            <div className="mx-auto my-6">
                <h1 className="mt-2 text-2xl font-bold tracking-tight sm:text-4xl">Contact Information:</h1>
                <p className="mt-6 text-lg leading-8">
                    For any privacy-related concerns or inquiries, please contact us at hello@EasyPairing.com.
                </p>  
            </div>
        </main>
    );
}